import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import axiosPlugin from './plugins/axios'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import '@mdi/font/css/materialdesignicons.min.css'



const vuetify = createVuetify({
    components: { ...components},
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
          mdi,
        },
      },
})

// createApp(App).use(router).use(vuetify).use(store).mount('#app')
// createApp(App).use(axiosPlugin, axios).use(router).use(vuetify).use(store).mount('#app')
createApp(App)
  .use(vuetify)
  .use(router)
  .use(store)
  .use(axiosPlugin, axios)
  .mount('#app')
